import { useState } from 'react';
import { prijaviSe } from '../hooks/usePodaci';
import Ikona from './Ikona';

export default function Prijava() {
  const [korisnickoIme, postaviKorisnickoIme] = useState('');
  const [lozinka, postaviLozinku] = useState('');
  const [vidljivaLozinka, postaviVidljivuLozinku] = useState(false);
  const [poruka, postaviPoruku] = useState(null);
  const [radi, postaviRadi] = useState(false);

  const posalji = async (e) => {
    e.preventDefault();
    if (radi) return;
    postaviRadi(true);
    postaviPoruku(null);
    try {
      await prijaviSe(korisnickoIme, lozinka);
    } catch (err) {
      postaviPoruku(err.message);
    } finally {
      postaviRadi(false);
    }
  };

  return (
    <main className="prijava-zaslon">
      <section className="prijava-prica">
        <div className="marka">
          <span className="znak-vodovoda">
            <Ikona naziv="kap" velicina={30} />
          </span>
          <span>
            vodovod
            <strong>
              Jakšinec<span>.</span>
            </strong>
          </span>
        </div>
        <div className="prijava-poruka">
          <span className="nadnaslov">HUM STUBIČKI · JAKŠINEC · KARIVAROŠ</span>
          <h1>
            Naš vodovod.
            <br />
            Naša zajednica.
          </h1>
          <p>
            Čuvamo znanje o vodovodu.
            <br />
            Za ljude koji ga danas koriste
            <br />i one koji dolaze poslije nas.
          </p>
          <div className="prijava-valovi" aria-hidden="true">
            <svg viewBox="0 0 600 160" fill="none">
              {[0, 20, 40, 60, 80].map((y) => (
                <path
                  key={y}
                  d={`M-30 ${70 + y}C90 ${-30 + y} 180 ${170 + y} 310 ${70 + y}S500 ${-30 + y} 640 ${70 + y}`}
                />
              ))}
            </svg>
          </div>
        </div>
        <span className="prijava-podnozje">
          PRIVATNI VODOVOD · OPĆINA GORNJA STUBICA
        </span>
      </section>
      <section className="prijava-obrazac">
        <form className="prijava" onSubmit={posalji}>
          <span className="ikona-ploha tirkiz">
            <Ikona naziv="lokot" velicina={24} />
          </span>
          <span className="nadnaslov">DOBRO DOŠLI</span>
          <h2>Prijava u evidenciju</h2>
          <p className="uvod">
            Prijavi se računom koji ti je dodijelila uprava vodovoda.
          </p>
          <label>
            Korisničko ime
            <input
              type="text"
              required
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              placeholder="Upiši korisničko ime"
              value={korisnickoIme}
              onChange={(e) => postaviKorisnickoIme(e.target.value)}
              disabled={radi}
            />
          </label>
          <label htmlFor="lozinka">Lozinka</label>
          <div className="polje-lozinke">
            <input
              id="lozinka"
              type={vidljivaLozinka ? 'text' : 'password'}
              required
              autoComplete="current-password"
              placeholder="Upiši lozinku"
              value={lozinka}
              onChange={(e) => postaviLozinku(e.target.value)}
              disabled={radi}
            />
            <button
              type="button"
              aria-label={
                vidljivaLozinka ? 'Sakrij lozinku' : 'Prikaži lozinku'
              }
              aria-pressed={vidljivaLozinka}
              onClick={() => postaviVidljivuLozinku(!vidljivaLozinka)}
            >
              <Ikona naziv="oko" velicina={19} />
            </button>
          </div>
          {poruka && (
            <p className="poruka greska" role="alert">
              {poruka}
            </p>
          )}
          <button className="gumb" type="submit" disabled={radi}>
            {radi ? 'Prijavljujem…' : 'Prijavi se'}
            <Ikona naziv="strelica" velicina={18} />
          </button>
          <p className="pomoc-prijave">
            Trebaš pristup ili novu lozinku?
            <br />
            <strong>Obrati se upravi vodovoda.</strong>
          </p>
          <div className="privatnost-prijave">
            <Ikona naziv="lokot" velicina={14} />
            <span>Podaci su dostupni samo ovlaštenim korisnicima.</span>
          </div>
        </form>
        <span className="prijava-potpis">
          Vodovod Jakšinec · Evidencija naše zajednice
        </span>
      </section>
    </main>
  );
}
